import { IEditVehiclePayload, IVehicleCreate, IVehicleListSearch } from "../../../../types/master/vehicleInterface";
import api from "../../../../lib/api";

export const createVehicleApi = async (data: IVehicleCreate) => {
  return await api.post(`/vehicle`, data);
};

export const getVehicleListApi = async (data: IVehicleListSearch) => {
  return await api.get(`/vehicle/${data.page}/${data.pageLimit}?search=${data?.search??""}`)
}

export const getVehicleDataByIdApi = async (id: number) => {
  return await api.get(`/vehicle/${id}`)
}

export const editVehicleDataByIdApi = async (payload: IEditVehiclePayload) => {
  return await api.put(`/vehicle/${payload.id}`, payload.data);
};